import Controller, { inject as controller } from "@ember/controller";

export default class LoginPageController extends Controller {
  @controller application;
}
